import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

const getLast5Execution = async () => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getLast5Suites&companyid=${user.companyid}`,
  );

  return response.data;
};

const useGetLast5ExecutionQuery = () => {
  return useQuery({
    queryKey: ["GetLast5Execution"],
    queryFn: () => getLast5Execution(),
    retry: true,
    enabled: true,
    cacheTime: 0,
    refetchIntervalInBackground: false,
    staleTime: 0,
  });
};

export default useGetLast5ExecutionQuery;
